import { defineStyleConfig } from '@chakra-ui/react';

const Link = defineStyleConfig({
  baseStyle: {
    color: 'blue.500',
  },
});

export default Link;
